import { jsx as o } from "react/jsx-runtime";
const t = "elo-gap", e = "elo-tablet", a = "elo-mobile", l = {
  gap: t,
  tablet: e,
  mobile: a
}, p = () => /* @__PURE__ */ o("div", { className: l.gap });
export {
  p as G
};
